import { lazy } from "react";
import { RouteSuspense } from "@/shared/routing/RouteSuspense";
import type { RouteObject } from "react-router-dom";

const ReviewsPage = lazy(() => import("@/modules/reviews/pages/ReviewsPage").then(module => ({ default: module.ReviewsPage })));

export const reviewsRoutes: RouteObject[] = [
  {
    path: "reviews",
    element: <RouteSuspense><ReviewsPage /></RouteSuspense>,
  },
];
